export default __webpack_public_path__ + "static/media/AlexKim-min.4046f89d.png";